export default {
  IsoDuration: {
    maxDurationError: '[en] Ошибка валидации. Максимальное значение таймера - {{}}',
  },
};
